import React from 'react'
import { connect } from 'react-redux'
import Truncate from 'react-truncate'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { chevronLeft, signOut } from 'react-icons-kit/fa'
import { HeroBody } from '../../views/layouts/Hero'
import Title from '../../views/typo/Title'
import config from '../../../config'
import { Icon } from 'react-icons-kit'
import styledComponents from 'styled-components'
import IconButton from '../../views/buttons/IconButton'
import { withAppRouterHandler } from '../../../modules/portal/withPortalIdByRoute'
import NotificationButton from '../notification-controller/NotificatioButton'
import DynamicLinkButton from '../dynamic-link/DynamicLinkButton'
class Navbar extends React.Component {
  state = {
    isActive: false,
  }

  menuToggle = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }))
  }

  render() {
    const { title, portalTitle, goBack, thumbnailImageId } = this.props

    return (
      <React.Fragment>
        <nav className="navbar is-info is-fixed-top">
          <div className="navbar-brand">
            <Link className="navbar-item" to={`portals`}>
              <Image
                src={`${config.imageURLPrefix}/${thumbnailImageId}`}
                alt="portal"
              />
              <Truncate lines={2} ellipsis={<span>...</span>}>
                {portalTitle}
              </Truncate>
            </Link>
            <a
              onClick={this.menuToggle}
              role="button"
              className={classNames('navbar-burger burger', {
                'is-active': this.state.isActive,
              })}
              aria-label="menu"
              aria-expanded="false"
            >
              <span aria-hidden="true" />
              <span aria-hidden="true" />
              <span aria-hidden="true" />
            </a>
          </div>
          <div
            className={classNames('navbar-menu', {
              'is-active': this.state.isActive,
            })}
          >
            <div className="navbar-start">
              <DynamicLinkButton />
            </div>
            <div className="navbar-end">
              <NotificationButton />
              <LogoutBtn />
            </div>
          </div>
        </nav>
      </React.Fragment>
    )
  }
}

// const Navbar = ({ title, portalTitle, goBack, thumbnailImageId }) => (
//   <div className="hero is-light">
//     <HeroBody>
//       <article className="media">
//         <figure className="media-left">
//           <LeftItemLayout>
//             {goBack ? (
//               <a onClick={goBack}>
//                 <span className="icon is-medium">
//                   <Icon icon={chevronLeft} size={22} color="lightgray" />
//                 </span>
//               </a>
//             ) : (
//               <Space />
//             )}
//             <figure className="image is-96x96">
//               {thumbnailImageId ? (
//                 <Image
//                   src={`${config.imageURLPrefix}/${thumbnailImageId}`}
//                   alt="portal"
//                 />
//               ) : (
//                 <Square />
//               )}
//             </figure>
//           </LeftItemLayout>
//         </figure>
//         <MediaContent>
//           <div className="content">
//             <Title>
//               <Truncate lines={2} ellipsis={<span>...</span>}>
//                 {portalTitle}
//               </Truncate>
//             </Title>
//             <div className="subtitle"> PORTAL </div>
//           </div>
//         </MediaContent>
//         <div className="media-right has-text-right">
//           <div className="title"> {title} </div>
//           <div className="buttons">
//             <DynamicLinkButton />
//             <NotificationButton />
//             <LogoutBtn />
//           </div>
//         </div>
//       </article>
//     </HeroBody>
//   </div>
// )

const LogoutBtn = withAppRouterHandler(({ redirectToSigninPage }) => (
  <a className="navbar-item" onClick={redirectToSigninPage}>
    <span className="icon">
      <Icon icon={signOut} />
    </span>
    <span>Sign out</span>
  </a>
))

const LeftItemLayout = styledComponents.div`
  display: flex;
  > *:not(:last-child) {
    margin-right: 16px;
  }
`

const Space = styledComponents.div`
  width: 32px;
  height: 100%;
`

const Square = styledComponents.div`
  width: 96px;
  height: 96px;
  background-color: gray;
`

const Image = styledComponents.img`
  border-color: gray;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  margin-right: 8px;
`

const MediaContent = styledComponents.div.attrs({
  className: 'media-content',
})`
  overflow: hidden !important;
`

export default connect(
  ({
    portal: { mainImageId: thumbnailImageId, title },
    info: { language },
  }) => ({
    portalTitle: title ? title[language] : '',
    thumbnailImageId,
  }),
)(Navbar)



// WEBPACK FOOTER //
// ./src/components/templates/navigation/NavBar.js